// extracted by mini-css-extract-plugin
export default {"opacityHover":"styles_opacityHover__uxj-Q","underlineHover":"styles_underlineHover__W3M6r","primaryTextHover":"styles_primaryTextHover__SsAcb"};